import SystemModal from "../Common/SystemModal";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import ajaxStationOwners from "../../util/remote/ajaxStationOwners";
const UpdateStationModal = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // Form fields
  const [station_owner_names, setstation_owner_names] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [contact2, setContact2] = useState("");
  const [address, setAdress] = useState("");
  // Populate form when modal opens
  useEffect(() => {
    if (props.data) {
      var data = props.data;
      setstation_owner_names(data.station_owner_names || "");
      setEmail(data.email || "");
      setContact(data.contact || "");
      setContact2(data.contact2 || "");
      setAdress(data.address || "");
      setAdress(data.address || "");
    }
  }, [props.data]);
  const allRowsFilled = () =>
    station_owner_names && email && contact && address;
  const handleUpdate = async (e, closeModal) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }
    const payload = {
      id: props.data.id,
      station_owner_names: station_owner_names,
      email: email,
      contact: contact,
      contact2: contact2,
      address: address,
    };
    setLoading(true);
    const response = await ajaxStationOwners.updatestation_owners(payload);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      props.func();
      setTimeout(() => {
        closeModal();
      }, 2000);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleUpdate(e, controls.close)}
        disabled={loading}
      >
        {loading ? "Updating..." : "Update Farm"}
      </button>
    </>
  );
  return (
    <SystemModal
      title="Update Fuel Station Owner"
      size="lg"
      footer={RenderFooter}
    >
      <Toaster />
      {loading && <Loader />}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Update Farm</h6>
                <form>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label>
                        Farm Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={station_owner_names}
                        onChange={(e) => setstation_owner_names(e.target.value)}
                        className="form-control"
                        placeholder="Enter farm name"
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label>
                        Email <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-control"
                        placeholder="Enter email"
                        required
                      />
                    </div>
                    <div className="col-md-6 mt-3">
                      <label>
                        Primary Contact <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={contact}
                        onChange={(e) => setContact(e.target.value)}
                        className="form-control"
                        placeholder="Enter primary contact number"
                        required
                      />
                    </div>
                    <div className="col-md-6 mt-3">
                      <label>Secondary Contact</label>
                      <input
                        type="text"
                        value={contact2}
                        onChange={(e) => setContact2(e.target.value)}
                        className="form-control"
                        placeholder="Enter secondary contact number (optional)"
                      />
                    </div>
                    <div className="col-md-6 mt-3">
                      <label>
                        Adress <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={address}
                        onChange={(e) => setAdress(e.target.value)}
                        className="form-control"
                        placeholder="Enter address"
                        required
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
export default UpdateStationModal;
